export const SET_ERROR = 'SET_ERROR';
export const SET_PAYMENT_ERROR = 'SET_PAYMENT_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';

export function setError(error = [], callback) {
  const err = error.length ? error : [error.message];
  return {
    type: SET_ERROR,
    error: err,
    callback: callback || null,
  };
}

export function setPaymentError(error) {
  return {
    type: SET_PAYMENT_ERROR,
    paymentError: error
  };
}

export function removeError() {
  return {
    type: REMOVE_ERROR,
  };
}
